import "../Main.css";
import "../css/fontawesome-5.14.0.min.css";
import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Footer from "../Footer/Footer";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import MobileMenuHome from "../Home/MobileMenuHome";
import HomeMenu from "../Home/HomeMenu";
import SideBar from "../Home/SideBar";
import { sideBarToggle } from "../Home/utils";
// import logo from "../logo.svg";


const Press: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

 
  const page = parseInt(searchParams.get("page") || "0", 10);
  const logosPerPage = 30;

  const logos: string[] = [    "/assets/l1.png",
    "/assets/l2.png",
    "/assets/l3.png",
    "/assets/l4.png",
    "/assets/l5.png",
    "/assets/l6.png",
    "/assets/l7.png",
    "/assets/l8.png",
    "/assets/l9.png",
    "/assets/l10.png",
    "/assets/l11.png",
    "/assets/l13.png",
    "/assets/l14.png",
    "/assets/l15.png",
    "/assets/l16.png",
    "/assets/l17.png",
    "/assets/l18.png",
    "/assets/l19.png",
    "/assets/l20.png",
    "/assets/l21.png",
    "/assets/l22.png",
    "/assets/l23.png",
    "/assets/l24.png",
    "/assets/l25.png",
    "/assets/l26.png",
    "/assets/l27.png",
    "/assets/l28.png",
    "/assets/l30.png",
    "/assets/l31.png",
    "/assets/l32.png",
    "/assets/l33.png",
    "/assets/ll3.png",
    "/assets/l34.png",
    "/assets/l35.png",
    "/assets/l36.png",
    "/assets/l37.png",
    "/assets/l38.png",
    "/assets/l39.png",
    "/assets/l40.png",
    "/assets/l41.png",
    "/assets/l42.png",
    "/assets/ll2.png",
    "/assets/l43.png",
    "/assets/l44.png",
    "/assets/l45.png",
    "/assets/l46.png",
    "/assets/l47.png",
    "/assets/l48.png",
    "/assets/l49.png",
    "/assets/l50.png",
    "/assets/l51.png",
    "/assets/l52.png",
    "/assets/l53.png",
    "/assets/l54.png",
    "/assets/l55.png",
    "/assets/l56.png",
    "/assets/l57.png",
    "/assets/l58.png",
    "/assets/l59.png",
    "/assets/l60.png",
    "/assets/l79.png",
    "/assets/l61.png",
    "/assets/l62.png",
    "/assets/l63.png",
    "/assets/l64.png",
    "/assets/l65.png",
    "/assets/l66.png",
    "/assets/l80.png",
    "/assets/l67.png",
    "/assets/l81.png",
    "/assets/l82.png",
    "/assets/l68.png",
    "/assets/l69.png",
    "/assets/l70.png",
    "/assets/l71.png",
    "/assets/l72.png",
    "/assets/l73.png",
    "/assets/l74.png",
    "/assets/l75.png",
    "/assets/l83.png",
    "/assets/l76.png",
    "/assets/l77.png",
    "/assets/l78.png",
    "/assets/l84.png",
    "/assets/l85.png",
    "/assets/l86.png",
    "/assets/l87.png",
    "/assets/l88.png",
    "/assets/l89.png",
    "/assets/l90.png",
    "/assets/l91.png",
    "/assets/l92.png",
    "/assets/l93.png",
    "/assets/l94.png",
    "/assets/l95.png",
    "/assets/l96.png",
    "/assets/l97.png",
    "/assets/l98.png",
    "/assets/l99.png",
    "/assets/l100.png",
    "/assets/l101.png",
    "/assets/l102.png",
    "/assets/l103.png",
    "/assets/l104.png",
    "/assets/l105.png",
    "/assets/l106.png",
    "/assets/e1.png",
    "/assets/l107.png",
    "/assets/e2.png",
    "/assets/l108.png",
    "/assets/l109.png",
    "/assets/l110.png",
    "/assets/l111.png",
    "/assets/l112.png",
    "/assets/l113.png",
    "/assets/l114.png",
    "/assets/e3.png",
    "/assets/e4.png",
    "/assets/l115.png",
    "/assets/l116.png",
    "/assets/l117.png",
    "/assets/e5.png",
    "/assets/l118.png",
    "/assets/l119.png",
    "/assets/l120.png",

    "/assets/l121.png",
    "/assets/l122.png",
    "/assets/l123.png",
    "/assets/l124.png",
    "/assets/l125.png",
    "/assets/e6.png",
    "/assets/l126.png",
    "/assets/l127.png",
    "/assets/l128.png",
    "/assets/l129.png",
    "/assets/l130.png",

    "/assets/l131.png",
    "/assets/l132.png",
    "/assets/l133.png",
    "/assets/l134.png",
    "/assets/l135.png",
    "/assets/e7.png",
    "/assets/l136.png",
    "/assets/l137.png",
    "/assets/l138.png",
    "/assets/e8.png",
    "/assets/l139.png",
    "/assets/e9.png",
    "/assets/l140.png",
    "/assets/l141.png",
    "/assets/l142.png",
    "/assets/l143.png",
    "/assets/l144.png",
    "/assets/l145.png",
    "/assets/l146.png",
    "/assets/l147.png",
    "/assets/l148.png",
    "/assets/l149.png",
    "/assets/l150.png",
    "/assets/l151.png",
    "/assets/e10.png",
    "/assets/l152.png",
    "/assets/l153.png",
    "/assets/e11.png",
    "/assets/l154.png",
    "/assets/l155.png",
    "/assets/l156.png",
    "/assets/l157.png",
    "/assets/l158.png",
    "/assets/l159.png",
    "/assets/l160.png",
    "/assets/l161.png",
    "/assets/l162.png",
    "/assets/l163.png",
    "/assets/l164.png",
    "/assets/l165.png",
    "/assets/e13.png",
    "/assets/e14.png",
    "/assets/l166.png",
    "/assets/l167.png",
    "/assets/l168.png",
    "/assets/e15.png",
    "/assets/l169.png",
    "/assets/l170.png",
    "/assets/l171.png",
    "/assets/l172.png",
    "/assets/l173.png",
    "/assets/l174.png",
    "/assets/l175.png",
    "/assets/l176.png",
    "/assets/l177.png",
    "/assets/l178.png",
    "/assets/l179.png",
    "/assets/q1.png",
    "/assets/q2.png",
    "/assets/q3.png",
    "/assets/q4.png",
    "/assets/c1.png",
    "/assets/q6.png",
    "/assets/q7.png",
    "/assets/q8.png",
    "/assets/q9.png",
    "/assets/q10.png",
    "/assets/q11.png",
    "/assets/q12.png",
    "/assets/c2.png",
    "/assets/q13.png",
    "/assets/q14.png",
    "/assets/q15.png",
    "/assets/q17.png",
    "/assets/q18.png",
    "/assets/q19.png",
    "/assets/q20.png",
    "/assets/q21.png",
    "/assets/q22.png",
];
  
  const totalPages = Math.ceil(logos.length / logosPerPage);
  const start = page * logosPerPage;
  const currentLogos = logos.slice(start, start + logosPerPage);

  const setPage = (newPage: number) => {
    setSearchParams({ page: newPage.toString() });
  };

  const handleClick = (logo: string, localIndex: number) => {
    const globalIndex = start + localIndex;
    navigate(`/presslogo/${globalIndex}`, { state: { logo } });
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="press-page">
    
      <header
        className={`main-header header-two ${scrolled ? "fixed-header" : ""}`}
        style={{
          position: "fixed", width: "100%", top: 0, zIndex: 1000,
          transition: "all 0.3s ease-in-out",
          backgroundColor: scrolled ? "#ffffff" : "transparent",
          boxShadow: scrolled ? "0px 4px 30px rgba(0, 0, 0, 0.25)" : "none",
        }}
      >
        <div className="header-upper1">
          <div className="container clearfix">
            <div className="header-inner rel d-flex align-items-center justify-content-between">
              <div className="logo-outer">
                <Link to="/"><img src="/assets/tth_logo.png" alt="Logo" style={{ height: scrolled ? "40px" : "45px", transition: "0.3s" }} /></Link>
              </div>
              <div className="nav-outer clearfix mx-0">
                <MobileMenuHome logo={"/images/logos/logo-two.png"} />
                <nav className="main-menu d-none d-lg-block navbar-expand-lg">
                  <div id="mainNavbar" className="navbar-collapse collapse clearfix"><HomeMenu /></div>
                </nav>
              </div>
              <div className="menu-btns">
                <div className="menu-sidebar d-none d-lg-block">
                  <button onClick={() => sideBarToggle()}><span className="icon-bar" /><span className="icon-bar" /><span className="icon-bar" /></button>
                  <SideBar />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      
      <div className="press-banner">
        <img src="/assets/logo.png" alt="Press Banner" className="img-fluid press-banner-img" />
        <div className="press-banner-content">
          <h1 style={{ color: "white", fontSize: "40px", fontWeight: "700" }}>Get Featured on 200+ Premium News Outlets.</h1>
          <p style={{ color: "white", fontSize: "16px", fontWeight: "400" }}>Stop pitching. Start publishing. Guaranteed placement for your brand.</p>
        </div>
      </div>

      <Container>
      
{page === 0 && (
  <div className="contentpart">
   
    <div className="content">
      <Row className="align-items-center">
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im2.png" alt="" className="img-fluid" />
          </div>
        </Col>
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">The Problem: Great Stories, Zero Visibility</h3>
            <p className="text-muted">
             You have a groundbreaking product or a powerful brand story, but you’re shouting into a void. Sending cold emails to journalists usually ends in silence, and hiring traditional PR firms costs thousands with no guarantee of coverage. In a digital world, if Google doesn't know you, customers won't trust you.
            </p>
          </div>
        </Col>
      </Row>
    </div>

    
    <div className="content">
      <Row className="align-items-center flex-column-reverse flex-md-row">
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">The Solution: Guaranteed Global Reach</h3>
            <p className="text-muted">
             Stop pitching and start publishing. We bridge the gap between your brand and the world’s media. We provide guaranteed placement across our exclusive network of 200+ premium news outlets. Whether you are a startup, an established enterprise, or a personal brand, we ensure your story goes live on high-authority sites where your customers are already reading.
</p>
          </div>
        </Col>
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im3.png" alt="" className="img-fluid" />
          </div>
        </Col>
      </Row>
    </div>

    
    <div className="content ">
      <Row className="align-items-center">
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im4.png" alt="" className="img-fluid" />
          </div>
        </Col>
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">Strategic Benefits: Why Press Coverage is Your Best Asset</h3>
            <p className="text-muted">
              In a crowded digital marketplace, having a great product isn't enough; you need to be trusted. Our network delivers three critical advantages that go beyond simple exposure to fundamentally change how the world views your brand. </p>
          </div>
        </Col>
      </Row>
    </div>

   
    <div className="content">
      <Row className="align-items-center flex-column-reverse flex-md-row">
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">Instant Credibility: The "As Seen On" Effect</h3>
            <p className="text-muted">
             Trust is the currency of the internet. When a potential customer lands on your website, they make a split-second decision: Is this business legitimate? By securing placement on recognized news outlets, you earn the legal right to display "As Seen On" logos (like FOX, NBC, or CBS affiliates) on your landing pages, social media, and email signatures. This is psychological "social proof." It signals to visitors that you are an established industry player, not a risky startup. Clients who display these trust badges report significantly higher conversion rates and shorter sales cycles.

            </p>
          </div>
        </Col>
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im5.png" alt="" className="img-fluid" />
          </div>
        </Col>
      </Row>
    </div>


    <div className="content ">
      <Row className="align-items-center">
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im6.png" alt="" className="img-fluid" />
          </div>
        </Col>
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">SEO Dominance: The Power of High-Authority Backlinks</h3>
            <p className="text-muted">
             Google loves news sites. Search engines view links from established media outlets as "votes of confidence" in your website. When our partner publications link back to your site, they pass on "link juice" that improves your Domain Authority (DA). Unlike low-quality directory links, these are contextual, high-value backlinks. Over time, this signals to Google that your brand is authoritative, helping you rank higher in search results for your own keywords and driving organic traffic long after the news cycle ends.
</p>
          </div>
        </Col>
      </Row>
    </div>

  
    <div className="content ">
      <Row className="align-items-center flex-column-reverse flex-md-row">
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">Verification Ready: The Blueprint for the Blue Tick</h3>
            <p className="text-muted">
              The coveted "Blue Tick" on Instagram, Facebook, and Twitter isn't just about popularity—it’s about notability. Social media platforms require proof that you are a public figure or a brand of public interest. They specifically look for articles in reputable news publications to verify your identity. Our distribution service creates the exact digital paper trail and third-party references required to submit a successful verification application. We provide the links you need to prove you are who you say you are </p>
          </div>
        </Col>
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im7.png" alt="" className="img-fluid" />
          </div>
        </Col>
      </Row>
    </div>

    <hr />

 
    <div className="content pt-5 m-25 ">
      <h2 className="fw-bold">The Workflow</h2>
      <p className="text-muted">We have stripped away the complexity of traditional PR. We handle the heavy lifting while you stay in control.</p>
    </div>

    
    <div className="content ">
      <Row className="align-items-center">
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im8.png" alt="" className="img-fluid" />
          </div>
        </Col>
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">Submit or Create</h3>
            <ul>
            <p className="text-muted"><b>The DIY Path:</b> If you already have a press release written, simply upload it to our dashboard. We will review it for formatting and editorial compliance to ensure it meets news standards.</p>
            <p className="text-muted"><b>The Done-For-You Path:</b>  Not a writer? No problem. Provide us with your basic details—your product launch, a new partnership, or a company milestone—and our team of expert business journalists will craft a professional, newsworthy story for you. We know exactly what angles grab attention.
</p>
          </ul></div>
        </Col>
      </Row>
    </div>


    <div className="content ">
      <Row className="align-items-center flex-column-reverse flex-md-row">
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">Approve</h3>
            <p className="text-muted">
             Your reputation is paramount, so nothing goes live without your express permission. If we write the story, we send the draft directly to you for review. You can request edits, tweak headlines, or adjust quotes until you are 100% satisfied. We only move to the distribution phase once you give us the "Green Light." This ensures accuracy and alignment with your brand voice.
 </p>
          </div>
        </Col>
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im9.png" alt="" className="img-fluid" />
          </div>
        </Col>
      </Row>
    </div>

   
    <div className="content">
      <Row className="align-items-center">
        <Col md={5} className="text-center pt-3 pt-md-5">
          <div className="logo">
            <img src="/assets/im10.png" alt="" className="img-fluid" />
          </div>
        </Col>
        <Col md={6}>
          <div className="pt-3 pt-md-5">
            <h3 className="fw-bold">Go Live & Report</h3>
            <p className="text-muted">
            Once approved, we push the button. Your story is syndicated instantly across our network of 200+ premium news sites. But we don't just tell you we did it; we prove it. Within 48 to 72 hours, you will receive a comprehensive White Label PDF Report. This document contains direct, clickable links to your story on every single publication. You can share this report with investors, partners, or your team to showcase the immediate impact of your campaign.
 </p>
          </div>
        </Col>
      </Row>
    </div>

    <div className="d-flex justify-content-center py-4 m-25">
      <button className="press-btn">View Our Publication List</button>
    </div>
    <hr />
  </div>
)}
     
        <div className="logo-grid">
          {currentLogos.map((logoItem, index) => {
            const globalIndex = start + index;
            return (
              <div key={globalIndex} className="logo-box" onClick={() => handleClick(logoItem, index)}>
                <img src={logoItem} alt={`Logo ${globalIndex}`} />
              </div>
            );
          })}
        </div>

      
        <div className="pagination">
          <button onClick={() => setPage(page - 1)} disabled={page === 0} className="pagination-btn fs-5"> ← </button>
          
          <button onClick={() => setPage(0)} className={`pagination-number ${page === 0 ? "active" : ""}`}>1</button>
          {page > 2 && <span className="dots">…</span>}

          {Array.from({ length: totalPages }, (_, i) => i)
            .filter((i) => i >= page - 1 && i <= page + 1 && i !== 0 && i !== totalPages - 1)
            .map((i) => (
              <button key={i} onClick={() => setPage(i)} className={`pagination-number ${page === i ? "active" : ""}`}>
                {i + 1}
              </button>
            ))}

          {page < totalPages - 3 && <span className="dots">…</span>}
          {totalPages > 1 && (
            <button onClick={() => setPage(totalPages - 1)} className={`pagination-number ${page === totalPages - 1 ? "active" : ""}`}>
              {totalPages}
            </button>
          )}

          <button onClick={() => setPage(page + 1)} disabled={page === totalPages - 1} className="pagination-btn fs-5"> → </button>
        </div>
      </Container>

      <Footer />
    </div>
  );
};

export default Press;